<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <div>
      <div class="bodyCenter">
        <div class="modalStyle">
          <div class="titulos">
            <div class="seccionTitle">
              <b-icon icon="person-lines-fill" class="mLeft"></b-icon>
              <div class="headerTxt mLeft">
                Bandeja de solicitudes de movimientos
              </div>
            </div>
          </div>
          <div
            class="flxDivs"
            v-if="$localStorageService.can('BO_22_bajedejaSolici')"
          >
            <div class="div90">
              <b-skeleton-table
                :rows="5"
                :columns="12"
                :table-props="{ bordered: true, striped: true }"
                v-if="cargandoTabla == true"
              ></b-skeleton-table>
              <span v-if="arrayTraspasos.length != 0">
                <b-table
                  responsive
                  striped
                  hover
                  :items="arrayTraspasos"
                  v-if="arrayTraspasos.length != 0 && cargandoTabla == false"
                  :current-page="currentPage"
                  :per-page="perPage"
                  thead-tr-class="columnas"
                >
                  <template #cell(Detalle)="row">
                    <b-button
                      variant="primary"
                      @click="abrirDetalle(row.item)"
                      :disabled="row.item['Estatus'] != 'ABIERTO'"
                      v-if="$localStorageService.can('BO_Ver_detalle')"
                    >
                      <em class="fa fa-eye"></em>
                    </b-button>
                  </template>
                  <template #cell(Documentos)="row">
                    <span v-if="row.item.Documentos.length != 0">
                      <span
                        v-for="imagen in row.item.Documentos"
                        v-bind:key="imagen"
                      >
                        <b-icon
                          icon="download"
                          v-b-tooltip.hover.top="'Descargar'"
                          @click="
                            downloadImage(
                              imagen.imagen,
                              row.item.Folio,
                              imagen.tipo
                            )
                          "
                          class="pointer"
                        ></b-icon>
                        <br />
                        <br />
                      </span>
                    </span>
                    <span v-else class="grayTxt"> Sin documentos </span>
                  </template>
                </b-table>
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="center"
                  aria-controls="my-table1"
                ></b-pagination>
                <br />
                <br />
              </span>
              <strong
                v-if="arrayTraspasos.length == 0 && cargandoTabla == false"
                >Sin solicitudes</strong
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-detalle" hide-footer>
      <template #modal-title>Movimiento de saldo</template>
      <div class="d-block text-left">
        <p><strong>Folio: </strong>{{ info.folio }}</p>
        <p><strong>Fecha de solicitud: </strong>{{ info.fecha }}</p>
        <p><strong>Clínica: </strong>{{ info.clinica }}</p>
        <p><strong>Solicitante: </strong>{{ info.solicitante }}</p>
        <p><strong>Nombre del paciente: </strong>{{ info.nombreP }}</p>
        <p><strong>Saldo: </strong>{{ info.saldoA }}</p>
        <p><strong>Saldo actual: </strong>{{ info.saldoActual }}</p>
        <p><strong>Razón del moviento: </strong>{{ info.razon }}</p>
        <b-form-group label="Estatus">
          <b-form-select
            v-model="estatusId"
            :options="opcionesEstatus"
            @change="actualizarEstatus(info.folio, estatusId)"
            v-if="$localStorageService.can('BO_23_actualizar_estatus')"
          ></b-form-select>
        </b-form-group>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('modal-detalle')"
        >Cerrar</b-button
      >
    </b-modal>
  </div>
</template>
<script>
//components
import Header from "../../components/Header.vue";
//import miniToastr from "mini-toastr"; //ES6

export default {
  name: "bandejaSolicitudesSaldo",
  components: {
    Header,
  },
  props: {
    msg: String,
    isDark: Boolean,
    "md-active-step": String,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    currentPage: 1,
    perPage: 15,
    totalRows: 1,
    cargandoTabla: false,
    arrayTraspasos: [],
    info: {},
    estatusId: null,
    opcionesEstatus: [
      {
        value: 4,
        text: "AUTORIZAR",
      },
      {
        value: 3,
        text: "RECHAZAR",
      },
    ],
    loading: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.ObtenerTraspasos();
  },
  methods: {
    downloadImage(blobImage, id, tipo) {
      var a = document.createElement("a"); //Create <a>
      a.href = "data:" + tipo + ";base64," + blobImage; //Image Base64 Goes here
      a.download = id; //File name Here
      a.click(); //Downloaded file
    },
    actualizarEstatus(folio, estatusId) {
      this.$swal
        .fire({
          title: "¿Estás seguro de actualizar el estatus?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            this.loading = true;
            this.$http
              .put(
                this.$api +
                  "saldo/actualizarTraspaso?idEstatusTraspaso=" +
                  estatusId +
                  "&idTraspaso=" +
                  folio +
                  "&idUsuario=" +
                  this.$localStorageService.getIdUsuario() +
                  "&comentario=null" +
                  "&monto=" +
                  0
              )
              .then(() => {
                this.estatusId = null;
                this.ObtenerTraspasos();
              })
              .catch((error) => {
                this.estatusId = null;
                console.error(error);
                this.banderaBtn = false;
                this.$swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
          },
        })
        .then((result) => {
          if (result.value) {
            this.$swal({
              icon: "success",
              title: "Se actualizó correctamente",
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                this.$bvModal.hide("modal-detalle");
              },
            });
          }
        });
    },
    abrirDetalle(datos) {
      this.$bvModal.show("modal-detalle");
      this.info = {
        folio: datos["Folio"],
        fecha: datos["Fecha de Solicitud"],
        clinica: datos["Clínica"],
        solicitante: datos["Solicitante"],
        nombreP: datos["Nombre del Paciente"],
        saldoA: datos["Monto"],
        saldoActual: datos["saldoActual"],
        razon: datos["Motivo"],
      };
    },
    ObtenerTraspasos() {
      this.cargandoTabla = true;
      this.$http
        .get(
          this.$api + "saldo/obtenerMovimientosPorEstatus?idEstatusTraspaso=1"
        )
        .then((response) => {
          this.cargandoTabla = false;
          if (response.status === 200) {
            this.arrayTraspasos = response.data.data.map((it) => {
              return {
                Folio: it.idTraspaso,
                "Fecha de Solicitud": this.$moment(it.fechaAlta)
                  .utc()
                  .format("DD/MM/YYYY"),
                Clínica: it.clinicaNombre,
                Solicitante: it.solicitanteNombre,
                Área: it.areaNombre,
                "Nombre del Paciente": it.pacienteNombre,
                "Tipo de Movimiento": it.tipoMovimiento,
                Clasificación: it.monto >= 0 ? "A favor" : "Negativo",
                "Fecha de solución":
                  it.estatus != "ABIERTO"
                    ? this.$moment(it.fechaAutorizacion)
                        .utc()
                        .format("DD/MM/YYYY")
                    : "",
                Monto: it.monto,
                saldoActual: it.saldoActual,
                Estatus: it.estatus,
                Motivo: it.comentarioMovimiento,
                "Días Transcurridos": it.diasTranscurridos,
                "Folio de Póliza ": it.folioPoliza,
                Validación:
                  it.estatus == "NO AUTORIZADO"
                    ? "Rechazado"
                    : it.estatus == "AUTORIZADO"
                    ? "Aceptado"
                    : "",
                Detalle: true,
                Documentos: it.imagenesTraspaso,
                "Comentario Rechazo":
                  it.comentarioAutorizacion != "null"
                    ? it.comentarioAutorizacion
                    : "",
              };
            });
            this.totalRows = this.arrayTraspasos.length;
          }
        })
        .catch((error) => {
          this.cargandoTabla = false;
          console.error(error);
        });
    },
  },
};
</script>
<style scoped>
.flxDivs {
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  padding-bottom: 20px;
  justify-content: space-around;
}

.div90 {
  width: 95%;
  border: 2px solid #b9cde6;
  padding: 1%;
  border-radius: 12px;
}

.pointer {
  cursor: pointer;
}

.grayTxt {
  color: gray;
}
</style>
